import script from "./RegisteredMembersPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisteredMembersPage2.vue?vue&type=script&setup=true&lang=js"

import "./RegisteredMembersPage2.vue?vue&type=style&index=0&id=28097d64&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28097d64"]])

export default __exports__